import moment from 'moment';
import { BYTES_IN_MB, EXTENSION_TYPE_MAP } from './constants';

export const getBytesFromMb = (num: number) => num * BYTES_IN_MB;
export const getMbFromBytes = (num: number) => num / BYTES_IN_MB;

export const getFileExtension = (filename: string): string => {
  if (typeof filename !== 'string') return '';

  const lastDot = filename.lastIndexOf('.');

  if (lastDot <= 0 || lastDot === filename.length - 1) {
    return '';
  }

  return filename.slice(lastDot + 1).toLowerCase();
};

export const getFileTypeFromName = (
  fileName: string,
): (typeof EXTENSION_TYPE_MAP)[keyof typeof EXTENSION_TYPE_MAP] | 'default' => {
  if (!fileName) return 'default';

  const extension = fileName.split('.').pop()?.toLowerCase() || '';
  return EXTENSION_TYPE_MAP[extension as keyof typeof EXTENSION_TYPE_MAP] || 'default';
};

export const mapToFileData = ({
  file,
  artifactTypeId,
}: {
  file: Blob & { name: string };
  artifactTypeId: string | number | Blob;
}) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('title', file.name);
  formData.append('artifact_type_id', artifactTypeId instanceof Blob ? artifactTypeId : String(artifactTypeId));
  return formData;
};

export const isLinkExpired = (urlString: string): boolean => {
  const url = new URL(urlString);

  const creationDate = moment.utc(url.searchParams.get('X-Amz-Date'));
  const expiresInSecs = Number(url.searchParams.get('X-Amz-Expires'));

  const expiryDate = creationDate.add(expiresInSecs, 'seconds');
  const currentDate = moment.utc();

  return currentDate > expiryDate;
};
